// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Your web app's Firebase configuration

const firebaseConfig = {
  /*
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  databaseURL: process.env.REACT_APP_databaseURL,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
*/

  
apiKey: "AIzaSyCrtzyzkzPVGdd_Zr7VJDWj1KR744wKego",
authDomain: "wphoto-b0d5c.firebaseapp.com",
databaseURL: process.env.REACT_APP_databaseURL,
projectId: "wphoto-b0d5c",
storageBucket: "wphoto-b0d5c.appspot.com",
messagingSenderId: "183118089471",
appId: "1:183118089471:web:c15cb0ba6b739f1999d0ca"
  
};

// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);




//initialize services

export const db = getFirestore(app);
